import axiosApi from "../axiosInstance";

const getIOMConfigurationList = async () => {
    try {
        const response = await axiosApi.post(`/IomApprovalConfiguration/GetApprovalConfigurations`);
        return response?.data;
    } catch (error) {
        console.log("Error getIOMConfigurationList===>:", error);
    }
};

const addIOMConfiguration = async (body) => {
    try {
        const response = await axiosApi.post(`/IomApprovalConfiguration/CreateApprovalConfigurations`, body);
        return response?.data;
    } catch (error) {
        console.log("Error addIOMConfiguration ===>", error);
    }
};

const deleteIOMApprovalConfiguration = async (body) => {
    try {
        const response = await axiosApi.post(`/IomApprovalConfiguration/DeleteApprovalConfigurationsById`, body);
        return response?.data;
    } catch (error) {
        console.log("Error deleteIOMApprovalConfiguration ===>", error);
    }
};

export const IOMConfigurationService = {
    getIOMConfigurationList,
    addIOMConfiguration,
    deleteIOMApprovalConfiguration,
}